var map = {
	"./additionalInfoIcon.svg": 510,
	"./arrowLeftIcon.svg": 511,
	"./arrowMediumTop.svg": 512,
	"./arrowRightIcon.svg": 513,
	"./arrowRightIconSharp.svg": 514,
	"./arrowRightSmallIcon.svg": 515,
	"./arrowScalableIcon.svg": 516,
	"./arrowSelect2.svg": 517,
	"./arrowSelectIcon.svg": 518,
	"./benefit1.svg": 519,
	"./benefit2.svg": 520,
	"./benefit3.svg": 521,
	"./cardsIcon.svg": 522,
	"./copyIcon copy.svg": 523,
	"./copyIcon.svg": 524,
	"./crossIcon.svg": 525,
	"./crossIcon2.svg": 526,
	"./crossIcon3.svg": 527,
	"./crossIconSmall.svg": 528,
	"./crossSmallIcon.svg": 529,
	"./defaultCategoryIcon.svg": 530,
	"./depNumberIcon.svg": 531,
	"./elfCentralIcon.svg": 532,
	"./equalitySign.svg": 533,
	"./errorIcon.svg": 421,
	"./eyeClosedIcon.svg": 534,
	"./eyeOpenIcon.svg": 535,
	"./favoritesIcon.svg": 536,
	"./favoritesLabelIcon.svg": 537,
	"./filterDivider.svg": 538,
	"./filterIcon.svg": 539,
	"./frequencyIcon.svg": 540,
	"./fsAmountIcon.svg": 541,
	"./fullScreenIcon.svg": 542,
	"./gameIcon.svg": 543,
	"./hamburgerIcon.svg": 544,
	"./infoIcon.svg": 545,
	"./infoSymbol.svg": 546,
	"./levelBackground.svg": 547,
	"./levelBackgroundNew.svg": 548,
	"./linkIcon.svg": 549,
	"./lockIcon.svg": 550,
	"./lockSharpIcon.svg": 551,
	"./maxBonusAmountIcon.svg": 552,
	"./maxWinFsIcon.svg": 553,
	"./menuIcon.svg": 554,
	"./minDepIcon.svg": 555,
	"./noTournamentIcon.svg": 556,
	"./playIcon.svg": 557,
	"./polygon.svg": 558,
	"./preloaderDotsAnimation.svg": 559,
	"./preloaderSpinnerAnimation.svg": 560,
	"./presentIcon.svg": 561,
	"./promoIcon.svg": 562,
	"./recentIcon.svg": 563,
	"./search2Icon.svg": 564,
	"./search3Icon.svg": 565,
	"./sharpTickIcon copy.svg": 566,
	"./sharpTickIcon.svg": 567,
	"./smallInfoSymbol.svg": 568,
	"./smoothArrowIcon.svg": 569,
	"./successIcon.svg": 570,
	"./supportIcon.svg": 571,
	"./tag1Icon.svg": 572,
	"./tag2Icon.svg": 573,
	"./tag3Icon.svg": 574,
	"./tag4Icon.svg": 575,
	"./tickIcon.svg": 576,
	"./unverified.svg": 577,
	"./verified.svg": 578,
	"./wagerIcon.svg": 579,
	"./wagerTimeIcon.svg": 580,
	"./warningIcon.svg": 581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 509;